import axios from 'axios'
import Config from '@/config/'

const menu = {
  strict: true,

  namespaced: true,

  state: {
    menuState: false,
    booking: false,
    light: '#f6eeeb',
    dark: '#2a2423',
    menuItems: {},
  },

  mutations: {
    SET_MENU (state, menu) {
      state.menuState = menu
    },
    SET_MENU_ITEMS (state, menuItems) {
      state.menuItems = menuItems
    },
    SET_BOOKING (state, open) {
      state.booking = open
    },
  },

  getters: {},

  actions: {
    menuToggle ({ commit }) {
      commit('SET_MENU', !this.menuState)
    },
    bookingToggle ({ commit }, open) {
      commit('SET_BOOKING', open)
    },
    setNavigation ({ commit }) {
      axios
        .get(Config.get('apiBase') + 'nav.json', {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(response => {
          commit('SET_MENU_ITEMS', response.data)
        })
    },
  },
}

export default menu
